import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ProfileModel } from "@app/core";
import { RoleTypes } from "core-kit";

@Injectable({ providedIn: "root" })
export class QuickSetupIntegrationService {
  constructor(private router: Router) {}

  ensureNavigated(user: ProfileModel) {
    var route = "/quick-setup";

    // Partner-business-type users go through the dedicated Partner Onboarding wizard.
    // Completion is tracked by doneQuickSetup (configured is already set at creation).
    if (user && user.role === RoleTypes.PartnerAdmin && !user.doneQuickSetup) {
      route = "/partner-onboarding";
    } else if (user && user.subscriptionId && user.subscriptionId !== "") {
      route = "/quick-setup-integration";
    }

    if (!this.router.routerState.snapshot.url.startsWith(route)) {
      this.router.navigate([route]);
    }
  }
}
